module.exports = __webpack_public_path__ + "img/3-2.1c81618b.svg";